import React from 'react'
import { ButtonGroup, ToggleButton } from 'react-bootstrap'
import { MeasureType } from './useSizeFilter'

export const MeasureTypeRadioButtons = ({
  name,
  onChange,
  measureType,
}: {
  onChange: any
  name: string
  measureType: string
}) => {
  return (
    <div>
      <ButtonGroup>
        <ToggleButton
          name={name}
          size="sm"
          variant="outline-primary"
          id={`${name}__in`}
          type="radio"
          value={MeasureType.in}
          onChange={onChange}
          checked={measureType === MeasureType.in}
        >
          Inches
        </ToggleButton>
        <ToggleButton
          size="sm"
          variant="outline-primary"
          name={name}
          id={`${name}__mm`}
          type="radio"
          value={MeasureType.mm}
          onChange={onChange}
          checked={measureType === MeasureType.mm}
        >
          Millimeters
        </ToggleButton>
      </ButtonGroup>
    </div>
  )
}
